function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1, .cls-2 {\n      fill: #fff;\n      }\n\n      .cls-2 {\n      font-family: Cern-Bold, Cern;\n      font-size: 44.09px;\n      font-weight: 700;\n      }\n\n      .cls-3 {\n      fill: #604082;\n      }\n\n      .cls-4 {\n      fill: #141c4d;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M250.02,492c-61.94,0-123.95-23.62-171.11-70.79C33.22,375.37,8,314.67,8,249.91s25.22-125.6,70.91-171.16c94.52-94.34,248.04-94.34,342.36,0h0c94.31,94.55,94.31,248.33,0,342.46-47.09,47.24-109.24,70.79-171.25,70.79Z"
}), React.createElement("g", {
  id: "_03"
}, React.createElement("path", {
  className: "cls-3",
  d: "M417.94,417.94c-92.76,92.75-243.13,92.75-335.88,0-92.75-92.75-92.75-243.12,0-335.88,92.75-92.75,243.12-92.75,335.88,0,92.75,92.76,92.75,243.13,0,335.88Z"
})), React.createElement("g", {
  id: "_03-2"
}, React.createElement("path", {
  className: "cls-1",
  d: "M423.49,250c0,95.81-77.68,173.48-173.49,173.48s-173.49-77.67-173.49-173.48S154.18,76.52,250,76.52s173.49,77.67,173.49,173.49Z"
})), React.createElement("g", {
  id: "_03-3"
}, React.createElement("path", {
  className: "cls-3",
  d: "M250,417.67c-92.46,0-167.68-75.22-167.68-167.67S157.54,82.33,250,82.33s167.68,75.22,167.68,167.68-75.22,167.67-167.68,167.67ZM250,87.33c-89.7,0-162.68,72.98-162.68,162.68s72.98,162.67,162.68,162.67,162.68-72.97,162.68-162.67-72.98-162.68-162.68-162.68Z"
})), React.createElement("text", null)), React.createElement("text", {
  className: "cls-2",
  transform: "translate(223.65 62.62) rotate(-3.83)"
}, React.createElement("tspan", {
  x: 0,
  y: 0
}, "E")), React.createElement("text", {
  className: "cls-2",
  transform: "translate(249.79 60.86) rotate(3.76)"
}, React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-4",
  d: "M340.92,151l-.1,181.78-63.85,16.22c-.79-5.29-.36-10.77-.41-16.11l48.27-12.07v-152.92h-149.65v148.89h101.37c.04,5.35-.05,10.74,0,16.1-37.48-1.01-75.67,1.34-113.08.03-1.53-.05-3.05.08-4.39-.84v-181.09h181.83Z"
}), React.createElement("polygon", {
  className: "cls-4",
  points: "257.24 193.66 257.24 215.39 222.24 215.39 222.24 231.48 257.24 231.48 257.24 253.21 221.84 253.21 221.84 269.31 257.24 269.31 257.24 291.04 200.12 291.04 200.12 193.66 257.24 193.66"
}), React.createElement("polygon", {
  className: "cls-4",
  points: "300.69 193.66 300.69 289.83 299.48 291.04 280.17 291.04 278.96 289.83 278.96 215.39 266.9 215.39 275.75 193.66 300.69 193.66"
}));

var SvgEstimateOneLogo = function SvgEstimateOneLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 70,
    height: 70,
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEstimateOneLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estimate-one-logo.3af84a54.svg";
export { ForwardRef as ReactComponent };